const PAYMENT_STATUSES = [
  { text: 'Unpaid', value: 'unpaid' },
  { text: 'Partially Paid', value: 'partial_paid' },
  { text: 'Paid', value: 'paid' },
  { text: 'Refunded', value: 'refunded' },
];

export const PAYMENT_STATUS_MAP = PAYMENT_STATUSES.reduce(
  (acc, val) => ({
    ...acc,
    [val.value]: val,
  }),
  {},
);

export default PAYMENT_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/paymentStatuses.js